import { StateCreator } from 'zustand';

interface IHint {
  hidden: boolean;
}
interface IHintState {
  defaultHint: IHint;
  hints: Record<string, IHint>;
}

interface IHintActions {
  setHint: (id: string, hint: IHint) => void;
  setDefault: (hint: IHint) => void;
}

export interface IHintStore extends IHintState, IHintActions {}

export const defaultHint = { hidden: false };

export const createHintSlice: StateCreator<IHintStore> = (set) => ({
  hints: {},
  defaultHint: defaultHint,
  setHint: (id: string, hint: IHint) => {
    set((state) => ({
      hints: {
        ...state.hints,
        [id]: hint,
      },
    }));
  },
  setDefault: (hint: IHint) => {
    set((state) => ({
      defaultHint: hint,
    }));
  },
});
